import { useState } from "react";
import { Typography, Stack, Divider } from "@financeable-com-au/financeable-ui";
import { useFeatureFlags } from "@/utils/featureFlags";
import { SIGNATURE_TYPE } from "@/constants";
import { Signature } from "../Signature";
import ServiceAgreement from "../Signature/ServiceAgreement";

export interface DisclosureParams {
  cid: string;
  aid: string;
  uid: string;
  templateType: string;
  jwt: string;
}

interface DisclosureSignatureProps {
  params: DisclosureParams;
}

const DisclosureStatement = ({ params }: DisclosureSignatureProps) => {
  const { documentTemplateUplift } = useFeatureFlags();
  const [submitted, setSubmitted] = useState(false);

  if (submitted) {
    return (
      <Stack flexDirection="column" rowGap={5} paddingBottom={10}>
        <Stack flexDirection="column" rowGap={2}>
          <Typography level="title-lg">Agreement Signed Successfully</Typography>
          <Typography level="body-lg">
            Too easy! You're one step closer and not far to go now. Enjoy the rest of your day.
          </Typography>
        </Stack>
        <Divider />
        <Typography level="body-md">You can close this window.</Typography>
      </Stack>
    );
  }
  return (
    <Stack flexDirection="column" rowGap={5} paddingBottom={10}>
      <Stack flexDirection="column" rowGap={2}>
        <Typography level="title-lg">Disclosure Statement</Typography>
        <Typography level="body-lg">Please read the disclosure statement then sign at the bottom.</Typography>
      </Stack>
      <Divider />
      {documentTemplateUplift() && <ServiceAgreement params={params} serviceAgreementType={SIGNATURE_TYPE.DISCLOSURE} />}
      <Signature signatureType={SIGNATURE_TYPE.DISCLOSURE} setSubmitted={setSubmitted} />
    </Stack>
  );
};

export default DisclosureStatement;
